import { useState, useEffect } from "react";
import PromoteursHeader from "./PromoteursHeader";
import PromoteursBody from "./PromoteursBody";
import PromoteursAdminBody from "./PromoteursAdminBody";
import { useDispatch, useSelector } from "react-redux";
import {
  getPromoteurs,
  getSecteurs,
} from "../../../redux/actions/promoteursActions";
import Pagination from "../../../components/commons/Pagination";
import AddPromoteur from "./AddPromoteur";
import { openModal } from "../../../redux/actions/modalActions";

const PromoteursList = () => {
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.userAuthReducer);
  const [searchfilter, setSearchfilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    field: "name",
    direction: "asc",
  });
  const { promoteurs, loading, secteurs } = useSelector(
    (state) => state.promoteursReducer
  );
  const { user } = useSelector((state) => state.userAuthReducer);
  useEffect(() => {
    dispatch(getSecteurs());
    dispatch(
      getPromoteurs(
        currentPage,
        25,
        searchfilter,
        sortConfig.field,
        sortConfig.direction
      )
    );
  }, [currentPage, dispatch, sortConfig.field, sortConfig.direction]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemSearch = () => {
    dispatch(
      getPromoteurs(
        1,
        25,
        searchfilter,
        sortConfig.field,
        sortConfig.direction,
        false
      )
    );
  };

  const handleSort = (field, direction) => {
    setSortConfig({ field, direction });
    setCurrentPage(1); // Reset to first page when sorting changes
  };

  const handleAddPromoteurModal = () => {
    dispatch(
      openModal({
        title: "Ajouter un Promoteur",
        content: <AddPromoteur sortConfig={sortConfig} />,
      })
    );
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <div>
      <PromoteursHeader
        searchfilter={searchfilter}
        setSearchfilter={setSearchfilter}
        handleItemSearch={handleItemSearch}
        showButton={
          role === "Administrateur" ||
          (role === "Collaborateur" && user?.createPromoter)
        }
        buttonText="Créer un promoteur"
        buttonCallBack={handleAddPromoteurModal}
      />
      {user?.profile === "Administrateur" ||
      (user?.profile === "Collaborateur" && user?.createPromoter) ? (
        <PromoteursAdminBody
          listePromoteurs={promoteurs}
          secteurs={secteurs}
          onSort={handleSort}
          sortConfig={sortConfig}
        />
      ) : (
        <PromoteursBody listePromoteurs={promoteurs} secteurs={secteurs} />
      )}
      {promoteurs?.meta?.pagination?.pageCount > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={promoteurs.meta.pagination.pageCount}
          onPageChange={handlePageChange}
          className="mt-20"
        />
      )}
    </div>
  );
};

export default PromoteursList;
